import React, { FormEvent, useState } from "react";
import Button from "../form-components/input/Button";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

export default function RepresentLitigant() {
	const token = sessionStorage.getItem("token");
	const navigate = useNavigate();

	const [formData, setFormData] = useState({
		suitNumber: "",
		counselType: "",
	});

	const [isSubmitting, setIsSubmitting] = useState(false);

	const handleSubmit = async function (e: FormEvent<HTMLFormElement>) {
		e.preventDefault();

		try {
			if (formData.counselType === "") {
				throw new Error("Counsel Type is required");
			}

			if (formData.suitNumber === "") {
				throw new Error("Suit Number is required");
			}

			setIsSubmitting(true);

			const response = await fetch(
				"https://backend-kyw8.onrender.com/cases/represent",
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						Authorization: "Bearer " + token,
					},
					body: JSON.stringify(formData),
				}
			);

			if (!response.ok) {
				const errorData = await response.json();
				throw new Error(errorData.message ?? errorData.error);
			}

			const successData = await response.json();

			toast.success(successData.message, {
				position: "top-center",
			});

			navigate("/dashboard");
		} catch (error) {
			const errorData = error as Error;
			toast.error(errorData.message, {
				position: "top-center",
			});
			setIsSubmitting(false);
		}
	};

	return (
		<div className="mt-[25px] w-full flex flex-col items-center">
			<h1 className="text-[30px] font-bold text-center">
				Represent a Litigant
			</h1>
			<div className="w-[60%] mt-[20px]">
				<form onSubmit={handleSubmit}>
					<div className="flex flex-col gap-y-4">
						<label htmlFor="counsel-type">Counsel Type</label>
						<select
							name="roles"
							id="counsel-type"
							onChange={(e) => {
								setFormData((prev) => ({
									...prev,
									counselType: e.target.value,
								}));
							}}
							className="rounded-lg border-[1.5px] border-gray-200 h-[50px]">
							<option disabled selected value={""}>
								Select Role
							</option>
							<option value="claimant">Claimant Counsel</option>
							<option value="defendant">Defendant Counsel</option>
						</select>
					</div>
					<div className="flex flex-col gap-y-4 mt-7">
						<label htmlFor="suitNumber">Suit Number</label>
						<input
							type="text"
							className="rounded-lg border-[1.5px] border-gray-200 h-[50px] p-5"
							id="suitNumber"
							placeholder="Enter suit number"
							onChange={(e) => {
								setFormData((prev) => ({
									...prev,
									suitNumber: e.target.value,
								}));
							}}
						/>
					</div>
					<Button
						type="submit"
						isLoading={isSubmitting}
						disabled={isSubmitting}
						buttonText="Join Case"
					/>
				</form>
			</div>
		</div>
	);
}